// Chuẩn hoá HTML do Quill 2 (react-quill-new) sinh ra TRƯỚC KHI lưu.
// Dùng chung cho mọi editor trong admin (Chương trình thưởng, Email...).
//
// Quill 2 gói MỌI danh sách trong <ol>, loại list nằm ở thuộc tính
// li[data-list="bullet"|"ordered"] và dấu đầu dòng vẽ bằng CSS
// (li > .ql-ui::before). Nơi hiển thị không có CSS của Quill — trang web
// (prose), app (react-native-render-html), email — sẽ đánh SỐ cho cả list
// dấu chấm. Vì vậy chuyển về HTML chuẩn: <ul> cho bullet, <ol> cho ordered,
// và bỏ <span class="ql-ui"> (chỉ phục vụ editor).

/** Tách <ol> của Quill 2 thành các đoạn liên tiếp cùng loại list */
function splitListByType(doc, list) {
    const items = Array.from(list.children).filter((el) => el.tagName === "LI");
    if (!items.length) return;

    const runs = [];
    items.forEach((li) => {
        // Không có data-list = list chuẩn (Quill 1 / HTML dán vào) → giữ thẻ cha
        const type = li.getAttribute("data-list") || (list.tagName === "UL" ? "bullet" : "ordered");
        const last = runs[runs.length - 1];
        if (last && last.type === type) last.items.push(li);
        else runs.push({ type, items: [li] });
    });

    const replacements = runs.map(({ type, items: runItems }) => {
        const el = doc.createElement(type === "bullet" ? "ul" : "ol");
        runItems.forEach((li) => {
            li.removeAttribute("data-list");
            el.appendChild(li);
        });
        return el;
    });

    replacements.forEach((el) => list.parentNode.insertBefore(el, list));
    list.remove();
}

/**
 * @param {string} html HTML lấy từ editor
 * @returns {string} HTML đã chuẩn hoá list (an toàn cho web/app/email)
 */
export function normalizeQuillListHtml(html) {
    if (!html || typeof html !== "string") return html;
    if (!html.includes("data-list") && !html.includes("ql-ui")) return html;

    const doc = new DOMParser().parseFromString(`<div id="root">${html}</div>`, "text/html");
    const root = doc.getElementById("root");
    if (!root) return html;

    root.querySelectorAll("span.ql-ui").forEach((node) => node.remove());
    // querySelectorAll trả snapshot tĩnh → thay thế trong vòng lặp vẫn an toàn
    root.querySelectorAll("ol, ul").forEach((list) => splitListByType(doc, list));

    return root.innerHTML;
}

/**
 * Trả &nbsp; về dấu cách thường.
 *
 * Quill 2 xuất HTML qua getSemanticHTML() và hàm này mã hoá MỌI dấu cách thành
 * &nbsp; (quill/dist: convertHTML → `.replaceAll(" ", "&nbsp;")`). Hệ quả: cả
 * đoạn văn thành một "từ" không ngắt được — nơi hiển thị chỉ còn xuống dòng
 * được ở "-", "(", ")", "/" nên dòng nhảy lung tung, đoạn không có các ký tự
 * đó thì tràn khung và mất chữ ở cuối (React Native không có word-break).
 *
 * @param {string} html
 * @returns {string}
 */
export function relaxNbsp(html) {
    if (!html || typeof html !== "string") return html;
    return html.replace(/&nbsp;|\u00a0/gi, " ");
}

/**
 * Chuẩn hoá đầy đủ HTML lấy từ editor Quill trước khi lưu: list chuẩn +
 * bỏ &nbsp; chặn ngắt dòng. Đây là hàm nên dùng ở các form.
 *
 * @param {string} html
 * @returns {string}
 */
export function normalizeQuillHtml(html) {
    return relaxNbsp(normalizeQuillListHtml(html));
}
